var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ccc;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.88,17.48H12.34c-.65,0-1.18-.53-1.18-1.18s.53-1.18,1.18-1.18h25.53c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.34,
    cy: 16.31,
    r: 1.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.88,26.18H12.34c-.65,0-1.18-.53-1.18-1.18s.53-1.18,1.18-1.18h25.53c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.32,
    y: 23.45,
    width: 3.11,
    height: 3.11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.88,34.87H12.34c-.65,0-1.18-.53-1.18-1.18s.53-1.18,1.18-1.18h25.53c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.34,
    cy: 33.69,
    r: 1.77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerGray);
export default __webpack_public_path__ + "static/media/burger_gray.4ff8024089280c587cd1c1c239465ab3.svg";
export { ForwardRef as ReactComponent };